import type { FeaturesDisplayModel } from '@core/models/features';
import { get } from '@shared/axios';

const fetchFeaturesByStudioId = async (studioId: number) =>
  await get<FeaturesDisplayModel[]>(`/api/studioadmin/studios/${studioId}/features`);

export { fetchFeaturesByStudioId };
